<template>
    <div style="">
        <div class="data-list" style="background:#fff;margin-top:10px;">
            <div class="index-top">
                <div class="content"><a-range-picker :default-value="[moment(getCurrentData(), 'YYYY-MM-DD'), moment(getCurrentData(), 'YYYY-MM-DD')]" :locale="locale" @change="ondateChange" /></div>
                <div class="content"><h3>飞象宝数据统计</h3></div>
                <div class="content"></div>   
            </div>
             
        </div>

        <div>
            <a-card title="销售简报" class="index-jb">
                <!-- <a slot="extra" href="#">more</a> -->
                <a-row type="flex" justify="space-between">
                    <a-col :span="11" class="menu-border">
                        <h2>新增</h2>
                        <a-row>
                            <a-col :span="8">
                                <strong>{{datainfo[0].value}}</strong>
                                <p>{{datainfo[0].name}}</p>
                            </a-col>
                            <a-col :span="8">
                                <strong>{{datainfo[3].value}}</strong>
                                <p>{{datainfo[3].name}}</p>
                            </a-col>

                            <a-col :span="8">
                                <strong>{{datainfo[2].value}}</strong>
                                <p>{{datainfo[2].name}}</p>
                            </a-col>
                        </a-row>   
                        <a-row>
                            <a-col :span="8">
                                <strong>{{datainfo[1].value}}</strong>
                                <p>{{datainfo[1].name}}</p>
                            </a-col>
                            <a-col :span="8">
                                <strong>{{datainfo[4].value | percent}}%</strong>
                                <p>{{datainfo[4].name}}</p>
                            </a-col>
                            <a-col :span="8">
                                <strong v-if="datainfo[5].value">{{datainfo[5].value | minTime}}</strong>
                                <strong v-else>0</strong>
                                <p>{{datainfo[5].name}}</p>
                            </a-col>
                        </a-row>  
                    </a-col>
                    <a-col :span="11" class="menu-border">
                        <h2>成交</h2>
                        <a-row>
                            <a-col :span="8">
                                <strong>{{datainfo[6].value}}</strong>
                                <p>{{datainfo[6].name}}</p>
                            </a-col>
                           
                            <a-col :span="8">
                                <strong>{{datainfo[8].value}}</strong>
                                <p>{{datainfo[8].name}}</p>
                            </a-col>
                            <a-col :span="8">
                                <strong>{{datainfo[10].value}}</strong>
                                <p>{{datainfo[10].name}}</p>
                            </a-col>
                        </a-row>     
                        <a-row>
                             <a-col :span="8">
                                <strong>{{datainfo[7].value}}</strong>
                                <p>{{datainfo[7].name}}</p>
                            </a-col>

                            
                            <a-col :span="8">
                                <strong>{{datainfo[9].value | percent}}%</strong>
                                <p>{{datainfo[9].name}}</p>
                            </a-col>
                            <a-col :span="8">
                                <strong>{{datainfo[11].value | percent}}%</strong>
                                <p>{{datainfo[11].name}}</p>
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </a-card>
        </div>

        <div class="index-charts" style="padding:0 10px;margin-top:20px">
            <div class="ld-charts">
                <div class="title">
                    <span></span>
                    <p>转化率</p>
                </div>
                <div id="charts2" style="width:100%;height:100%">

                </div>
            </div>
            <div class="zz-charts">
                <div class="title">
                    <span></span>
                    <p>增长趋势</p>
                </div>
                <div id="charts4" style="width:100%;height:100%">
                    
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import echarts from "echarts";
import moment from 'moment'
import Vue from 'vue'
Vue.prototype.$echarts = echarts
export default {
    filters: {
        percent(text){
            return parseInt(text*100)
        },
        minTime(min) {
            let minTime = "";
            let h = Math.floor(min / 60);
            min -= h * 60;
            if (min == 0) {
            minTime = h ? "0" + h + ":00" : "";
            } else {
            if (min < 10) {
                min = "0" + min;
            }
            // if (h < 10) {
            //     h = "0" + h;
            // }
            minTime = (h ? h + "h" : "00h") + (min ? min + "m" : "");
            }
            return minTime;
        }
    },
    data(){
        return{
            locale,
            datainfo:"",

            starttime:moment(moment().format('YYYY-MM-DD')+' 00:00:01').unix(),
            endtime:moment(moment().format('YYYY-MM-DD')+' 23:59:59').unix()
        }
    },
    mounted(){
        var t;
        this.getdata()
        var that=this
        clearTimeout(t)
        t = setTimeout(function (){
            that.getzh()
            that.getup()
       },800)
    },
    methods:{
        moment,
        getCurrentData(){
            return new Date().toLocaleDateString();
            
        },
        // 日期范围
        ondateChange(date,dateString){
       
            this.starttime=moment(dateString[0]+' 00:00:01').unix()
            this.endtime=moment(dateString[1]+' 23:59:59').unix()
            this.getdata()
            this.getzh()
        },
        // 销售简报
        getdata(){
            this.$axios.post('/api/datastatistics/usersourcessaleskit',{
                starttime:this.starttime,
                endtime:this.endtime
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.datainfo=res.data.data
                }else{
                    this.$message.error(res.data.msg); 
                }
                
            })
        },
        // 转化率
        getzh(){
            this.$axios.post('/api/datastatistics/usersourcesrate',{
                starttime:this.starttime,
                endtime:this.endtime
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var charts2 = this.$echarts.init(document.getElementById("charts2"))
                    charts2.setOption({
                        color: ['#f9ba1d','#0aa293','#6495fb','#0baa6a'],
                        tooltip: {
                            trigger: 'item',
                            formatter: "{a} <br/>{b} : {c}%"
                        },

                        series: [
                            {
                                name:'漏斗图',
                                type:'funnel',
                                left: '2%',
                                top: 50,
                                bottom:40,
                                width: '80%',
                                min: res.data.data[3].value,
                                max: res.data.data[0].value,
                                minSize: '20%',
                                maxSize: '90%',
                                sort: 'descending',
                                gap: 8,
                                // label: {
                                //     show: true,
                                //     position: 'inside',
                                //     formatter:'{b} {c}'
                                // },
                                // itemStyle: {
                                //     borderColor: '#fff',
                                //     borderWidth: 0
                                // },
                                label: {
                                    formatter: '{b} {c}',
                                    color:'#333',

                                },
                                labelLine: {
                                    length: 50,
                                    lineStyle: {
                                        width: 0,
                                        type: 'solid'
                                    }
                                },
                                itemStyle: {
                                    borderColor: '#fff',
                                    borderWidth: 0
                                },
                                emphasis: {
                                    label: {
                                        fontSize: 20
                                    }
                                },
                                data:  res.data.data
                            },
                            {
                                name:'漏斗图',
                                type:'funnel',
                                left: '2%',
                                top: 50,
                                bottom:40,
                                width: '80%',
                                min: res.data.data[3].value,
                                max: res.data.data[0].value,
                                minSize: '20%',
                                maxSize: '90%',
                                sort: 'descending',
                                gap: 8,
                                //  label: {
                                //     formatter: '{b} {c}',
                                //     color:'#333'
                                // },
                                // labelLine: {
                                //     length: 50,
                                //     lineStyle: {
                                //         width: 0,
                                //         type: 'solid'
                                //     }
                                // },
                                // itemStyle: {
                                //     borderColor: '#fff',
                                //     borderWidth: 0
                                // },
                                label: {
                                    show: true,
                                    position: 'inside',
                                    formatter: '{b}'
                                },
                                itemStyle: {
                                    borderColor: '#fff',
                                    borderWidth: 0
                                },
                                emphasis: {
                                    label: {
                                        fontSize: 20
                                    }
                                },
                                data: res.data.data
                            }
                        ]
                    })
                }else{
                    this.$message.error(res.data.msg); 
                }
                
            })
        
        },

        // 增长趋势
        getup(){
            this.$axios.post('/api/datastatistics/usersourcesincrease',{},{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var charts4 = this.$echarts.init(document.getElementById("charts4"))
                    charts4.setOption({

                        tooltip: {
                            trigger: 'axis'
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '8%',
                            top:'10%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: res.data.data.curdate
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                             {
                                name: '已拨打',
                                type: 'line',
                                itemStyle: {
                                    normal: {
                                        color: '#b65ed8',
                                        lineStyle:{
                                            width:4//设置线条粗细
                                        }
                                    }
                                },
                                data: res.data.data.calldetail
                            },
                            {
                                name: '客户',
                                type: 'line',
                                itemStyle: {
                                    normal: {
                                        color: '#5e96f3',
                                        lineStyle:{
                                            width:4//设置线条粗细
                                        }
                                    }
                                },
                                data: res.data.data.userxs
                            },
                            {
                                name: '订单',
                                type: 'line',
                                itemStyle: {
                                    normal: {
                                        color: '#fcae06',
                                        lineStyle:{
                                            width:4//设置线条粗细
                                        }
                                    }
                                },
                                data: res.data.data.order
                            },
                            {
                                name: '激活',
                                type: 'line',
                                itemStyle: {
                                    normal: {
                                        color: '#6fdcb3',
                                        lineStyle:{
                                            width:4//设置线条粗细
                                        }
                                    }
                                },
                                data: res.data.data.activation
                            }
                        ]
                    })
                }else{
                    this.$message.error(res.data.msg); 
                }
                
            })
            
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/index/index.vue